<template>
  <div>
    <div
      class="city-modal__cross b-nav-bar__panel-btns-item b-nav-bar__panel-btns-item--cross"
      @click="$emit('close')"
    >
      <div
        class="b-nav-bar__panel-menu-icon _close"
      >
        <span />
        <span />
        <span />
      </div>
    </div>
    <transition
      name="fade-top"
      mode="out-in"
    >
      <div
        v-if="!isShowSelectCity"
        class="city-modal__header"
      >
        <div class="city-modal__title">
          <span v-if="otherCityMode">
            Подскажите, где Вы находитесь
          </span>
          <span v-else>
            Ваш город <span class="city-modal__title-text">{{ allCities[activeCity.id].name }}</span>?
          </span>
        </div>
        <div
          class="city-modal__preselect"
        >
          <div class="city-modal__preselect-other">
            <CoreButton
              class="city-modal__btn city-modal__preselect-other-btn"
              type="ghost-grey"
              @click="isShowSelectCity = true"
            >
              Выбрать другой
            </CoreButton>
          </div>
          <div class="city-modal__preselect-accept">
            <CoreButton
              class="city-modal__btn city-modal__preselect-accept-btn"
              type="green"
              @click="setCurrentCity()"
            >
              {{ 'Да' }}
            </CoreButton>
          </div>
        </div>
      </div>
      <div
        v-else
        class="city-modal__body"
      >
        <div class="city-modal__cities">
          <div class="city-modal__cities-title">
            Выберите ваш город
          </div>
          <div class="city-modal__cities-wrapper">
            <div
              v-for="city in sortedCities"
              :key="city.name"
              class="city-modal__city"
              :class="{
                'city-modal__city--active': city.id == selectedCity?.id
              }"
              @click="selectCity(city)"
            >
              {{ city.name }}
            </div>
          </div>
        </div>

        <CoreButton
          class="city-modal__btn city-modal__preselect-accept-btn"
          type="green"
          @click="setActive()"
        >
          Готово
        </CoreButton>
      </div>
    </transition>
  </div>
</template>

<script>
import Cookies from '@/services/cookies'
import CoreButton from '@/components/core/ui/CoreButton.vue'
import { mapGetters, mapActions } from 'vuex'
import { CITY_SELECTOR_REMOVE_CMZ } from '@/config/constants'

export default {
  name: 'CitySelectorV2',
  components: {
    CoreButton,
  },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    iconMode: {
      type: Boolean,
      default: false,
    },
    arrowIcon: {
      type: Boolean,
      default: true,
    },
    newLanding: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['onChangeVcp', 'close'],
  data () {
    return {
      selectedCity: null,
      isShowSelectCity: false,
      needReload: false,
    }
  },
  computed: {
    ...mapGetters({
      allCities: 'city/getAll',
      activeCity: 'city/getActive',
      otherCityMode: 'city/isOtherCityMode',
      specificQueryParams: 'marketing/specificQueryParams',
    }),
    sortedCities () {
      return Object.values(this.allCities).sort((item, item2) => item2.id - item.id)
    },
  },
  created () {
    this.selectedCity = this.activeCity
  },
  methods: {
    ...mapActions({
      confirmActiveWithMenu: 'city/confirmActiveWithMenu',
      confirmActive: 'city/confirmActive',
      setOtherCityMode: 'city/setOtherCityMode',
    }),
    setCurrentCity () {
      this.removeCmz()
      this.confirmActive(this.activeCity)
      this.setOtherCityMode({ flag: false })
      Cookies.set('city_confirmed', true, { expires: 30 })

      if (this.needReload) {
        location.reload()
      }
      this.$emit('close')
    },
    selectCity (city) {
      if (city.forceLandingRedirect && city.landingUrl) {
        window.location.href = city.landingUrl
        return
      }
      this.selectedCity = city
    },
    removeCmz () {
      const cmz = this.specificQueryParams.cmz || Cookies.get('cmz')
      if (CITY_SELECTOR_REMOVE_CMZ.includes(cmz) && this.selectedCity.id !== 2) {
        Cookies.remove('cmz')
        const url = new URL(window.location.href)
        url.searchParams.delete('cmz')
        window.history.replaceState(null, '', url.toString())
        this.needReload = true
      }
    },
    async setActive () {
      this.removeCmz()

      this.sendGTMMarkupEvent({ block: 'Navbar', element: 'CitySelector', action: 'Select', details: this.selectedCity.alias })
      this.confirmActive(this.selectedCity)
      this.$emit('onChangeVcp', { cityId: this.selectedCity.id })
      if (this.$route.name === 'MenuPageByType') {
        this.$router.push({
          name: 'MenuPageByType',
          params: {
            city: this.selectedCity.alias,
            type: this.$route.params.type,
            data: this.$route.params.data,
          },
        })
      }
      this.setOtherCityMode({ flag: false })
      Cookies.set('city_confirmed', true, { expires: 30 })

      if (this.needReload) {
        location.reload()
      }
      this.$emit('close')
    },
  },
}
</script>

<style lang="scss">

.city-modal {
  width: 100%;
  border-radius: 0;
    box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.1);
  &__wrapper {
    align-items: flex-start;
    backdrop-filter: blur(7px);
    &.active {
      background: rgba(255, 255, 255, 0.8);
    }
  }
  &__cross {
    position: absolute;
    top: 0.12rem;
    right: 0.04rem;
    z-index: 1000;
  }
  &__btn {
    padding: 0.12rem;
    width: 100%;
    height: .44rem;
    border-radius: 100px;
    text-transform: none;
    font-size: 0.16rem;
    line-height: 0.19rem;
  }
}

.city-modal__current {
  font-size: 0.16rem;
  margin-right: 0.05rem;
}

.city-modal__header {
}

.city-modal__title {
  font-weight: 600;
  font-size: .26rem;
  line-height: .36rem;
  padding: .36rem .28rem .32rem;
  color: map-get($colors, 'black');
  max-width: 2.2rem;
}
.city-modal__title-text {
  white-space: nowrap;
}

.city-modal__preselect {
  position: relative;
  display: flex;
  flex-flow: row wrap;
  padding: 0 0.24rem 0.4rem;
  margin-left: -0.04rem;
  margin-right: -0.04rem;
  padding-bottom: 0.19rem;

  &:after {
    position: absolute;
    content: '';
    display: block;
    height: 0.01rem;
    background-color: map-get($colors, 'grey-8');
    left: 0.04rem;
    right: 0.04rem;
    bottom: 0;
  }
}

.city-modal__preselect--no-bb {
  &:after {
    content: none;
  }
}

.city-modal__preselect-accept {
  flex: 0 0 50%;
  max-width: 50%;
  padding-left: 0.04rem;
  padding-right: 0.04rem;
}

.city-modal__preselect-other {
  flex: 0 0 50%;
  max-width: 50%;
  padding-left: 0.04rem;
  padding-right: 0.04rem;
}

.city-modal__preselect-other-btn {
  white-space: nowrap;
  font-weight: 600;
}

.city-modal__body {
  @include padding-x(0.24rem);
  padding-top: 0.36em;
  padding-bottom: 0.40em;
}

.city-modal__cities {
  @include row;
  position: relative;

  &:after {
    position: absolute;
    content: '';
    display: block;
    background-color: map-get($colors, 'grey-8');
    height: 0.01rem;
    left: 0;
    right: 0;
    bottom: 0;
  }
}

.city-modal__cities-title {
  width: 100%;
  font-size: 0.16rem;
  line-height: 0.19rem;
  font-weight: 400;
  color: map-get($colors, 'grey_80');
  margin-bottom: 0.28rem;
}

.city-modal__cities-wrapper {
  width: 100%;
  margin-bottom: 0.32rem;
  display: flex;
  flex-direction: column;
}

.city-modal__city {
  font-size: .26rem;
  line-height: .32rem;
  color: map-get($colors, 'black');
  cursor: pointer;
  font-weight: bold;
  transition: color .3s;
  &--active {
    color: map-get($colors, 'green_dark_10');
  }
  &:not(:last-child) {
    margin-bottom: 0.12rem;
  }
}

.city-modal__other {
  font-size: 0.12rem;
  line-height: 0.18rem;
  padding: 0.11rem 0.24rem;
  font-weight: 700;
  color: map-get($colors, 'gray_60');
}

.city-modal__other-city-button {
  font-size: 0.12rem;
  line-height: 0.18rem;
  font-weight: 700;
  color: map-get($colors, 'gray_60');
  text-align: center;
  padding: 0.11rem 0.24rem;
  display: flex;
  flex-flow: row wrap;
  align-items: center;
  cursor: pointer;
}

.city-modal__other-city-button-icon {
  margin-left: 0.02rem;
}

.city-modal__other-city-button-icon-sprite {
  width: 0.08rem;
  height: 0.06rem;
}

</style>
